export default __webpack_public_path__ + "static/media/2.9ae93a65.mp4";